function convertPixelToPercentage(pixelTop, pixelLeft) {
  const scaleTop = 0.5
  const scaleLeft = 0.337
  let percentageTop = pixelTop * scaleTop
  let percentageLeft = pixelLeft * scaleLeft

  return {
    top: percentageTop,
    left: percentageLeft,
  }
}

function convertScenesDifferences(scenes) {
  return scenes.map(scene => ({
    ...scene,
    differences: scene.differences.map(diff => ({
      ...diff,
      ...convertPixelToPercentage(diff.top, diff.left),
    })),
  }))
}

export { convertScenesDifferences }
